<div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
    <div class="toast" role="status" [ngClass]="[textClass, backgroundClass]" aria-live="polite" aria-atomic="true" data-bs-autohide="true" id="sampleToast" #sampleToast>
        <div class="toast-header" [ngClass]="backgroundClass">
            <!-- <img [src]="imagesUrl+'favicon.ico'" class="rounded me-2 img-fluid" width="20" height="20" alt="toast-icon"> -->
            <strong class="me-auto" [ngClass]="textClass" [innerHtml]="title"></strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body" [innerHtml]="body">
        </div>
    </div>
</div>